import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { selectPerms } from '../components/core/auth/authSlice';

export const useRo = () => {
  const perms = useSelector(selectPerms);
  const location = useLocation();
  const url = location?.pathname ?? '';
  const urlArr = url.split('/');
  const path = urlArr[urlArr.length - 1];
  const roPerms = perms?.R;
  const isReadOnly = roPerms.includes(path);
  const roleName = perms?.RN;

  return [isReadOnly, roleName];
};
